export { default as AuthProvider } from "./context/provider";

export const signupUrl = `/signup/`;
export const signupProfile = `/signup/profile/`;
export const loginUrl = `/login`;
